import classNames from 'classnames';

import BpkImage, {
  withLazyLoading,
  withLoadingBehavior,
} from '@skyscanner/backpack-web/bpk-component-image';

import ImageCaption from './ImageCaption';

import type { ImageProps } from '@skyscanner-internal/landing-pages-shared-types/types-shared/ImageProps';

import STYLES from './Image.module.scss';

const documentIfExists = typeof window !== 'undefined' ? document : null;
const LazyLoadedImage = withLoadingBehavior(
  withLazyLoading(BpkImage, documentIfExists),
);

const ImageContent = ({
  altText,
  credit,
  description,
  height,
  lazy = false,
  src,
  title,
  width,
}: ImageProps) => {
  const bpkImageProps = {
    altText,
    aspectRatio: width / height,
    src,
  };

  const hasCaption = credit || title || description;

  return (
    <>
      {lazy ? (
        <LazyLoadedImage {...bpkImageProps} />
      ) : (
        <BpkImage {...bpkImageProps} />
      )}
      {hasCaption && (
        <ImageCaption credit={credit} description={description} title={title} />
      )}
    </>
  );
};

const Image = ({ maxWidth, ...rest }: ImageProps) => (
  <div
    className={classNames([
      STYLES.Image,
      maxWidth && STYLES['Image--with-max-width'],
    ])}
  >
    {maxWidth ? (
      <div
        data-testid="image-max-width-container"
        {...(maxWidth && {
          style: { maxWidth: `${maxWidth}px`, width: '100%' },
        })}
      >
        <ImageContent {...rest} />
      </div>
    ) : (
      <ImageContent {...rest} />
    )}
  </div>
);

export default Image;
